// extracted by mini-css-extract-plugin
export default {"rating":"styles-module--rating--ffda0"};